module.exports = __webpack_public_path__ + "img/Uneven Tension.e63b26c6.png";